import React from "react";
import "./Agenda.css";

const Agenda = () => {
    return (
        <section id="agenda-geral">
            {/* Agenda do google */}
            <iframe
                src="https://calendar.google.com/calendar/embed?src=oliveiramariasilveira%40gmail.com&ctz=Europe%2FLisbon"
                frameBorder="0"
                scrolling="no"
                id="agenda-google"
                title="Google Agenda Embed"
            />
            {/* Botão para agendar */}
            <a
                href="https://calendly.com/oliveirasilveira-ana/30min"
                target="_blank"
                rel="noopener noreferrer"
                id="agenda-botao"
            >
                Agendar reunião
            </a>
        </section>
    )
}
export default Agenda;